import { render, staticRenderFns } from "./LFooter.vue?vue&type=template&id=f2e1d492&scoped=true&"
import script from "./LFooter.vue?vue&type=script&lang=js&"
export * from "./LFooter.vue?vue&type=script&lang=js&"
import style0 from "./LFooter.vue?vue&type=style&index=0&id=f2e1d492&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e1d492",
  null
  
)

export default component.exports